/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the entity types that custom fields can have.
 */
export enum CustomFieldEntityType {
    CONTACT = 'CONTACT',
    COMPANY = 'COMPANY',
    FUNNEL_CONVERSATION = 'FUNNEL_CONVERSATION',
    FUNNEL_CHANNEL_SESSION = 'FUNNEL_CHANNEL_SESSION',
    PRODUCT = 'PRODUCT',
    PROPERTY = 'PROPERTY',
}
